export enum ArrivedFrom {
  AllEvents = 'ALL_EVENTS',
  HotmartClubHome = 'HOTMART_CLUB_HOME',
  CertificatePage = 'CERTIFICATE_PAGE'
}
